export default __webpack_public_path__ + "static/media/ig.787b1447.svg";